const permissions = {
  login: {name: "用户登录", code: "login"},
  forgetPassSendSms: {name: "获取忘记密码的手机短信", code: "forgetPassSendSms"},
  forgetPassVerificationSms: {name: "验证忘记密码的手机短信", code: "forgetPassVerificationSms"},
  forgetPassResetPass: {name: "修改用户的密码", code: "forgetPassResetPass"},
  sendLoginSms: {name: "发送登录验证码短信", code: "sendLoginSms"},
  checkLoginSms: {name: "验证登录验证码", code: "checkLoginSms"},
  getUKeyCert: {name: "获取用户登录证书", code: "getUKeyCert"},
  addUser: {name: "新增用户", code: "addUser"},
  delUser: {name: "删除用户", code: "delUser"},
  queryUser: {name: "查询用户", code: "queryUser"},
  viewUser: {name: "获取用户详情", code: "viewUser"},
  editUser: {name: "修改用户信息", code: "editUser"},
  queryAcmVerify: {name: "查询待审批记录", code: "queryAcmVerify"},
  acceptAcmVerify: {name: "通过审批", code: "acceptAcmVerify"},
  batchAcceptAcmVerify: {name: "批量通过审批", code: "batchAcceptAcmVerify"},
  rejectAcmVerify: {name: "通过审批", code: "rejectAcmVerify"},
  batchRejectAcmVerify: {name: "批量拒绝审批", code: "batchRejectAcmVerify"},
  addRole: {name: "新增角色", code: "addRole"},
  delRole: {name: "删除角色", code: "delRole"},
  queryRole: {name: "查询角色", code: "queryRole"},
  queryProvinceRole: {name: "查询角色", code: "queryProvinceRole"},

  timeReading:{name:"时间阅览",code:"timeReading"},

  viewRole: {name: "获取角色详情", code: "viewRole"},
  editRole: {name: "修改角色信息", code: "editRole"},
  queryPermission: {name: "查询权限", code: "queryPermission"},
  relateRolePermission: {
    name: "关联角色权限关系", code: "relateRolePermission"
  },
  relateRolePermissionShow: {
    name: "菜单权限分配", code: "relateRolePermissionShow"
  },
  removeRolePermission: {
    name: "撤销角色权限关系", code: "removeRolePermission"
  },
  queryPermissionRole: {
    name: "查询权限的角色", code: "queryPermissionRole"
  },
  loadRolePermission: {
    name: "查询角色的权限", code: "loadRolePermission"
  },
  loginInformation: {
    name: '查询登录信息', code: 'loginInformation'
  },
  restoreUser: {
    name: "启用", code: "restoreUser"
  },
  forbidUser: {
    name: "停用", code: "forbidUser"
  },

  restoreRole: {
    name: "启用", code: "restoreRole"
  },
  forbidRole: {
    name: "停用", code: "forbidRole"
  },
  queryUserRole: {
    name: "获取用户关联的角色", code: "queryUserRole"
  },
  relateUserRole: {
    name: "关联角色权限关系", code: "relateUserRole"
  },
  removeUserRole: {
    name: "撤销角色权限关系", code: "removeUserRole"
  },

  batchRelateUserRole: {
    name: "用户批量分配业务范围", code: "batchRelateUserRole"
  },

  queryQqAdDataReport: {name: "查询腾讯广告数据报表", code: "queryQqAdDataReport"},
  exportQqAdDataReport: {name: "腾讯广告数据报表导出", code: "exportQqAdDataReport"},
  exportQqAdClueRegion: {name: "腾讯地域数据报表导出", code: "exportQqAdClueRegion"},
  queryQqClueRegionReport: {name: "查询腾讯广告数据报表地域分布", code: "queryQqClueRegionReport"},
  queryUserActionReport: {name: "查询用户行为报表的接口", code: "queryUserActionReport"},
  queryAdAccount: {name: "查询广告账号", code: "queryAdAccount"},
  deleteAdAccount: {name: "删除广告账号", code: "deleteAdAccount"},
  addAdAccount: {name: "新增广告账号", code: "addAdAccount"},
  logout: {name: "用户退出", code: "logout"},
  personalPassword: {name: "修改自己的密码", code: "personalPassword"},


  addWfWorkflowMain: {name: "新增流程主表", code: "addWfWorkflowMain"},
  queryWfWorkflowMain: {name: "查询流程主表", code: "queryWfWorkflowMain"},
  delWfWorkflowMain: {name: "删除流程主表", code: "delWfWorkflowMain"},
  viewWfWorkflowMain: {name: "获取流程主表", code: "viewWfWorkflowMain"},
  editWfWorkflowMain: {name: "修改流程主表", code: "editWfWorkflowMain"},
  addWfWorkflowAudit: {name: "新增审批流程表", code: "addWfWorkflowAudit"},
  queryWfWorkflowAudit: {name: "查询审批流程表", code: "queryWfWorkflowAudit"},
  delWfWorkflowAudit: {name: "删除审批流程表", code: "delWfWorkflowAudit"},
  viewWfWorkflowAudit: {name: "获取审批流程表", code: "viewWfWorkflowAudit"},
  editWfWorkflowAudit: {name: "修改审批流程表", code: "editWfWorkflowAudit"},
  addWfWorkflowNode: {name: "新增流程节点表", code: "addWfWorkflowNode"},
  queryWfWorkflowNode: {name: "查询流程节点表", code: "queryWfWorkflowNode"},
  delWfWorkflowNode: {name: "删除流程节点表", code: "delWfWorkflowNode"},
  viewWfWorkflowNode: {name: "获取流程节点表", code: "viewWfWorkflowNode"},
  editWfWorkflowNode: {name: "修改流程节点表", code: "editWfWorkflowNode"},
  addLimitation: {name: "新增限制库", code: "addLimitation"},
  queryLimitation: {name: "查询限制库", code: "queryLimitation"},
  delLimitation: {name: "删除限制库", code: "delLimitation"},
  viewLimitation: {name: "获取限制库", code: "viewLimitation"},
  editLimitation: {name: "修改限制库", code: "editLimitation"},
  downloadFile: {name: "下载文件", code: "downloadFile"},
  updateFile: {name: "上传文件", code: "updateFile"},
  updateFileCurr: {name: "上传文件", code: "updateFileCurr"},
  // RegisterupdateFile: {name: "上传文件", code: "RegisterupdateFile"},
  UuIdImges: {name: "图片uuid", code: "UuIdImges"},
  viewImage: {name: "预览图片", code: "viewImage"},

  editAudit: {name: "修改审批流程", code: "editAudit"},

  manualDataPush: {name: "手工推送数据", code: "manualDataPush"},

  queryAuditsByBussinessId: {name: "获取审批意见列表", code: "queryAuditsByBussinessId"},

  querylimitationtwo: {name: "获取限制库区域数据", code: "querylimitationtwo"},
  cancelPush: {name: "取消推送", code: "cancelPush"},


  queryMsgSysmsg: {name: "获取系统消息", code: "queryMsgSysmsg"},

  addBaseDictBasic: {name: "新增字典", code: "addBaseDictBasic"},
  queryDictByDictTypeBasic: {name: "查询字典", code: "queryDictByDictTypeBasic"},
  delBaseDictBasic: {name: "删除字典", code: "delBaseDictBasic"},
  viewBaseDictBasic: {name: "获取字典", code: "viewBaseDictBasic"},
  viewBaseDictByDictType: {name: "根据类型获取字典详情", code: "viewBaseDictByDictType"},
  editBaseDictBasic: {name: "修改字典", code: "editBaseDictBasic"},
  addBaseSubjectBasic: {name: "新增任教学科", code: "addBaseSubjectBasic"},
  querySubjectsBasic: {name: "查询任教学科", code: "querySubjectsBasic"},
  delBaseSubjectBasic: {name: "删除任教学科", code: "delBaseSubjectBasic"},
  viewBaseSubjectBasic: {name: "获取任教学科", code: "viewBaseSubjectBasic"},
  editBaseSubjectBasic: {name: "修改任教学科", code: "editBaseSubjectBasic"},
  getProvincesBasic: {name: "查询任教学科门类", code: "getProvincesBasic"},
  normal: {name: "获取学校列表", code: "normal"},
  addBaseOrgAnnulLogBasic: {name: "新增机构撤销日志", code: "addBaseOrgAnnulLogBasic"},
  getOrgAnnulLogDataBasic: {name: "查询机构撤销日志", code: "getOrgAnnulLogDataBasic"},
  delBaseOrgAnnulLogBasic: {name: "删除机构撤销日志", code: "delBaseOrgAnnulLogBasic"},
  viewBaseOrgAnnulLogBasic: {name: "获取机构撤销日志", code: "viewBaseOrgAnnulLogBasic"},
  editBaseOrgAnnulLogBasic: {name: "修改机构撤销日志", code: "editBaseOrgAnnulLogBasic"},
  addBaseRareWordsBasic: {name: "新增生僻字信息表", code: "addBaseRareWordsBasic"},
  queryBaseRareWordsBasic: {name: "查询生僻字信息表", code: "queryBaseRareWordsBasic"},
  delBaseRareWordsBasic: {name: "删除生僻字信息表", code: "delBaseRareWordsBasic"},
  viewBaseRareWordsBasic: {name: "获取生僻字信息表", code: "viewBaseRareWordsBasic"},
  editBaseRareWordsBasic: {name: "修改生僻字信息表", code: "editBaseRareWordsBasic"},
  addBaseOrgCetNumBasic: {name: "新增机构证书号码", code: "addBaseOrgCetNumBasic"},
  queryBaseOrgCetNumBasic: {name: "查询机构证书号码", code: "queryBaseOrgCetNumBasic"},
  delBaseOrgCetNumBasic: {name: "删除机构证书号码", code: "delBaseOrgCetNumBasic"},
  viewBaseOrgCetNumBasic: {name: "获取机构证书号码", code: "viewBaseOrgCetNumBasic"},
  editBaseOrgCetNumBasic: {name: "修改机构证书号码", code: "editBaseOrgCetNumBasic"},
  addBaseCertTypeLinkBasic: {name: "新增资格种类关联表", code: "addBaseCertTypeLinkBasic"},
  queryBaseCertTypeLinkBasic: {name: "查询资格种类关联表", code: "queryBaseCertTypeLinkBasic"},
  delBaseCertTypeLinkBasic: {name: "删除资格种类关联表", code: "delBaseCertTypeLinkBasic"},
  viewBaseCertTypeLinkBasic: {name: "获取资格种类关联表", code: "viewBaseCertTypeLinkBasic"},
  editBaseCertTypeLinkBasic: {name: "修改资格种类关联表", code: "editBaseCertTypeLinkBasic"},
  addBaseCollegeTagBasic: {name: "新增高校标签关联表", code: "addBaseCollegeTagBasic"},
  queryBaseCollegeTagBasic: {name: "查询高校标签关联表", code: "queryBaseCollegeTagBasic"},
  delBaseCollegeTagBasic: {name: "删除高校标签关联表", code: "delBaseCollegeTagBasic"},
  viewBaseCollegeTagBasic: {name: "获取高校标签关联表", code: "viewBaseCollegeTagBasic"},
  editBaseCollegeTagBasic: {name: "修改高校标签关联表", code: "editBaseCollegeTagBasic"},
  addBaseOrgHisoryLogBasic: {name: "新增机构权限上收日志", code: "addBaseOrgHisoryLogBasic"},
  getOrgHisoryLogDataBasic: {name: "查询机构权限上收日志", code: "getOrgHisoryLogDataBasic"},
  delBaseOrgHisoryLogBasic: {name: "删除机构权限上收日志", code: "delBaseOrgHisoryLogBasic"},
  viewBaseOrgHisoryLogBasic: {name: "获取机构权限上收日志", code: "viewBaseOrgHisoryLogBasic"},
  editBaseOrgHisoryLogBasic: {name: "修改机构权限上收日志", code: "editBaseOrgHisoryLogBasic"},
  addBaseOrgLockTimeBasic: {name: "新增机构锁定", code: "addBaseOrgLockTimeBasic"},
  queryBaseOrgLockTimeBasic: {name: "查询机构锁定", code: "queryBaseOrgLockTimeBasic"},
  delBaseOrgLockTimeBasic: {name: "删除机构锁定", code: "delBaseOrgLockTimeBasic"},
  viewBaseOrgLockTimeBasic: {name: "获取机构锁定", code: "viewBaseOrgLockTimeBasic"},
  editBaseOrgLockTimeBasic: {name: "修改机构锁定", code: "editBaseOrgLockTimeBasic"},
  addBaseTechnicalJobBasic: {name: "新增专业技术职务", code: "addBaseTechnicalJobBasic"},
  getTechnicalJobDataBasic: {name: "查询专业技术职务", code: "getTechnicalJobDataBasic"},
  delBaseTechnicalJobBasic: {name: "删除专业技术职务", code: "delBaseTechnicalJobBasic"},
  viewBaseTechnicalJobBasic: {name: "获取专业技术职务", code: "viewBaseTechnicalJobBasic"},
  editBaseTechnicalJobBasic: {name: "修改专业技术职务", code: "editBaseTechnicalJobBasic"},
  addBaseOrgTagBasic: {name: "新增机构标签信息表", code: "addBaseOrgTagBasic"},
  queryBaseOrgTagBasic: {name: "查询机构标签信息表", code: "queryBaseOrgTagBasic"},
  delBaseOrgTagBasic: {name: "删除机构标签信息表", code: "delBaseOrgTagBasic"},
  viewBaseOrgTagBasic: {name: "获取机构标签信息表", code: "viewBaseOrgTagBasic"},
  editBaseOrgTagBasic: {name: "修改机构标签信息表", code: "editBaseOrgTagBasic"},
  addBaseCertTypeBasic: {name: "新增资格种类", code: "addBaseCertTypeBasic"},
  getCertTypeListBasic: {name: "查询资格种类", code: "getCertTypeListBasic"},
  delBaseCertTypeBasic: {name: "删除资格种类", code: "delBaseCertTypeBasic"},
  viewBaseCertTypeBasic: {name: "获取资格种类", code: "viewBaseCertTypeBasic"},
  editBaseCertTypeBasic: {name: "修改资格种类", code: "editBaseCertTypeBasic"},
  addBaseCollegeBasic: {name: "新增高校", code: "addBaseCollegeBasic"},
  queryCollegesBasic: {name: "查询高校", code: "queryCollegesBasic"},
  delBaseCollegeBasic: {name: "删除高校", code: "delBaseCollegeBasic"},
  viewBaseCollegeBasic: {name: "获取高校", code: "viewBaseCollegeBasic"},
  editBaseCollegeBasic: {name: "修改高校", code: "editBaseCollegeBasic"},
  addBaseDictTypeBasic: {name: "新增字典类别", code: "addBaseDictTypeBasic"},
  queryBaseDictTypeBasic: {name: "查询字典类别", code: "queryBaseDictTypeBasic"},

  queryScoreBatch: {name: "查询国考批次", code: "queryScoreBatch"},
  queryNormalBatch: {name: "查询免试批次", code: "queryNormalBatch"},


  delBaseDictTypeBasic: {name: "删除字典类别", code: "delBaseDictTypeBasic"},
  viewBaseDictTypeBasic: {name: "获取字典类别", code: "viewBaseDictTypeBasic"},
  editBaseDictTypeBasic: {name: "修改字典类别", code: "editBaseDictTypeBasic"},
  exportLocaleSet: {name: "导出确认点信息", code: "exportLocaleSet"},
  downloadImgRs: {name: "下载导入数据的结果", code: "downloadImgRs"},
  importLocaleSet: {name: "导入确认点信息", code: "importLocaleSet"},
  addBaseOrgBasic: {name: "新增机构", code: "addBaseOrgBasic"},
  exportOrg: {name: "导出机构", code: "exportOrg"},
  getBaseOrgCertType:{name:"该机构可受理资格种类",code:"getBaseOrgCertType"},


  querySiteOrgLog: {name: "查询机构公示痕迹信息", code: "querySiteOrgLog"},
  queryBaseOrgBasic: {name: "查询机构", code: "queryBaseOrgBasic"},
  queryBaseOrgByOrgIdsBasic: {name: "查询确认点对应的机构信息", code: "queryBaseOrgByOrgIdsBasic"},
  delBaseOrgBasic: {name: "删除机构", code: "delBaseOrgBasic"},
  viewBaseOrgBasic: {name: "获取机构", code: "viewBaseOrgBasic"},
  editBaseOrgBasic: {name: "修改机构", code: "editBaseOrgBasic"},
  addBaseOrgCertTypeBasic: {name: "新增机构与资格种类对应表", code: "addBaseOrgCertTypeBasic"},
  queryBaseOrgCertTypeBasic: {name: "查询机构与资格种类对应表", code: "queryBaseOrgCertTypeBasic"},
  delBaseOrgCertTypeBasic: {name: "删除机构与资格种类对应表", code: "delBaseOrgCertTypeBasic"},
  viewBaseOrgCertTypeBasic: {name: "获取机构与资格种类对应表", code: "viewBaseOrgCertTypeBasic"},
  editBaseOrgCertTypeBasic: {name: "修改机构与资格种类对应表", code: "editBaseOrgCertTypeBasic"},
  addOrgNameLogBasic: {name: "新增机构更名日志", code: "addOrgNameLogBasic"},
  queryOrgNameLogBasic: {name: "查询机构更名日志", code: "queryOrgNameLogBasic"},
  delOrgNameLogBasic: {name: "删除机构更名日志", code: "delOrgNameLogBasic"},
  cancelOrgNameLog: {name: "删除机构更名日志", code: "cancelOrgNameLog"},
  viewOrgNameLogBasic: {name: "获取机构更名日志", code: "viewOrgNameLogBasic"},
  editOrgNameLogBasic: {name: "修改机构更名日志", code: "editOrgNameLogBasic"},
  addBaseOrgDictBasic: {name: "新增字典机构授权", code: "addBaseOrgDictBasic"},
  queryBaseOrgDictBasic: {name: "查询字典机构授权", code: "queryBaseOrgDictBasic"},
  delBaseOrgDictBasic: {name: "删除字典机构授权", code: "delBaseOrgDictBasic"},
  viewBaseOrgDictBasic: {name: "获取字典机构授权", code: "viewBaseOrgDictBasic"},
  editBaseOrgDictBasic: {name: "修改字典机构授权", code: "editBaseOrgDictBasic"},
  addBaseOrgDisableBasic: {name: "新增机构计划锁定", code: "addBaseOrgDisableBasic"},
  queryBaseOrgDisableBasic: {name: "查询机构计划锁定", code: "queryBaseOrgDisableBasic"},
  delBaseOrgDisableBasic: {name: "删除机构计划锁定", code: "delBaseOrgDisableBasic"},
  viewBaseOrgDisableBasic: {name: "获取机构计划锁定", code: "viewBaseOrgDisableBasic"},
  editBaseOrgDisableBasic: {name: "修改机构计划锁定", code: "editBaseOrgDisableBasic"},
  addBaseMajorBasic: {name: "新增所学专业", code: "addBaseMajorBasic"},
  queryMajorsBasic: {name: "查询所学专业", code: "queryMajorsBasic"},
  delBaseMajorBasic: {name: "删除所学专业", code: "delBaseMajorBasic"},
  viewBaseMajorBasic: {name: "获取所学专业", code: "viewBaseMajorBasic"},
  editBaseMajorBasic: {name: "修改所学专业", code: "editBaseMajorBasic"},
  queryMajorKVBasic: {name: "查询所学专业", code: "queryMajorKVBasic"},

  querySubjectKVBasic: {name: "查询任教学科KV", code: "querySubjectKVBasic"},
  getRootTechnicalJobDataBasic: {name: "获取专业技术职务根分类", code: "getRootTechnicalJobDataBasic"},
  orgRenameBasic: {name: "机构更名", code: "orgRenameBasic"},
  orgAnnulBasic: {name: "机构撤销与合并", code: "orgAnnulBasic"},
  transferHistoryDataBasic: {name: "转移历史数据", code: "transferHistoryDataBasic"},
  getTreeDataBasic: {name: "获取机构tree", code: "getTreeDataBasic"},

  addRmsUsbKeyBasic: {name: "新增USBKey管理", code: "addRmsUsbKeyBasic"},
  queryRmsUsbKeyBasic: {name: "查询USBKey管理", code: "queryRmsUsbKeyBasic"},
  delRmsUsbKeyBasic: {name: "删除USBKey管理", code: "delRmsUsbKeyBasic"},
  viewRmsUsbKeyBasic: {name: "获取USBKey管理", code: "viewRmsUsbKeyBasic"},
  editRmsUsbKeyBasic: {name: "修改USBKey管理", code: "editRmsUsbKeyBasic"},
  rmsUsbKeyGetDataBasic: {name: "查询USBKey管理", code: "rmsUsbKeyGetDataBasic"},
  getRmsUsbKeyDataBasic: {name: "获取rmsUseKey", code: "getRmsUsbKeyDataBasic"},

  getReOrgDataBasic: {name: "获取机构更名下拉机构列表", code: "getReOrgDataBasic"},
  getRegOrgDataBasic: {name: "获取机构权限上收下拉机构列表", code: "getRegOrgDataBasic"},
  onlyEditBaseOrgBasic: {name: "修改机构不关联资格种类", code: "onlyEditBaseOrgBasic"},
  onlyEcertSwitch: {name: "修改机构电子证照启用状态", code: "onlyEcertSwitch"},


  addCertBatchxx: {name: "新增认定批次", code: "addCertBatchxx"},
  queryCertBatchxx: {name: "查询认定批次", code: "queryCertBatchxx"},
  delCertBatchxx: {name: "删除认定批次", code: "delCertBatchxx"},
  viewCertBatchxx: {name: "获取认定批次详情", code: "viewCertBatchxx"},
  editCertBatchxx: {name: "修改认定批次", code: "editCertBatchxx"},
  getProvinceBasic: {name: "获取省份", code: "getProvinceBasic"},

  addProvinceBatchxx: {name: "新增省级批次计划", code: "addProvinceBatchxx"},
  queryProvinceBatchxx: {name: "查询省级批次计划", code: "queryProvinceBatchxx"},
  delProvinceBatchxx: {name: "删除省级批次计划", code: "delProvinceBatchxx"},
  viewProvinceBatchxx: {name: "获取省级批次计划详情", code: "viewProvinceBatchxx"},
  editProvinceBatchxx: {name: "修改省级批次计划", code: "editProvinceBatchxx"},
  checkProvinceBatchAddxx: {name: "检查是否可新增省级批次计划", code: "checkProvinceBatchAddxx"},

  queryProvinceBatchPostponexx: {name: "查询省级批次计划调整", code: "queryProvinceBatchPostponexx"},

  addLocaleSetxx: {name: "新增确认点安排", code: "addLocaleSetxx"},
  queryLocaleSetxx: {name: "查询确认点安排", code: "queryLocaleSetxx"},
  delLocaleSetxx: {name: "删除确认点安排", code: "delLocaleSetxx"},
  viewLocaleSetxx: {name: "获取确认点安排详情", code: "viewLocaleSetxx"},

  getLocaleSetDataByLocalSetId: {name: "根据确认点编号查询确认点安排", code: "getLocaleSetDataByLocalSetId"},
  changeLocalSetInfo: {name: "检查是否可以处理认定数据", code: "changeLocalSetInfo"},

  canAudRegData: {name: "修改确认点信息", code: "canAudRegData"},

  getOtherLocalRegistrations: {name: "查询其他确认点报名信息", code: "getOtherLocalRegistrations"},
  getOtherOrgRegistrations: {name: "根据证件查询申请信息", code: "getOtherOrgRegistrations"},
  queryLimitCert: {name: "查询临时证书表", code: "queryLimitCert"},
  deleteLimitCert: {name: "删除临时证书", code: "deleteLimitCert"},
  getSubRegistrations: {name: "查询其他机构确认点报名信息", code: "getSubRegistrations"},
  getReceiveRegInfos: {name: "认定受理数据接口", code: "getReceiveRegInfos"},

  receiveRegInfos: {name: "受理认定信息", code: "receiveRegInfos"},

  // changeLocalSet: {name: "认定数据修改确认点", code: "changeLocalSet"},

  editLocaleSetxx: {name: "修改确认点安排", code: "editLocaleSetxx"},
  localeSetDataxx: {name: "查询确认点安排", code: "localeSetDataxx"},
  getLocaleSetDataxx: {name: "查询安排确认点工作", code: "getLocaleSetDataxx"},
  orgAddLocalPoint: {name: "用于机构添加工作确认点", code: "orgAddLocalPoint"},


  getRegistrationsxx: {name: "查询用户申请报名信息", code: "getRegistrationsxx"},

  addOrgBatchPlanxx: {name: "提交机构网报计划", code: "addOrgBatchPlanxx"},

  queryOrgBatchxx: {name: "查询机构业务计划", code: "queryOrgBatchxx"},

  queryCertificateUserByOrgIds: {name: "根据机构id查询确认用户", code: "queryCertificateUserByOrgIds"},

  queryEnrollUserByOrgIds: {name: "根据机构id查询确认用户", code: "queryEnrollUserByOrgIds"},
  getMyOrgBatchxx: {name: "查询设置本机构认定网报计划", code: "getMyOrgBatchxx"},
  viewOrgBatchxx: {name: "查看机构业务计划详情", code: "viewOrgBatchxx"},

  getOrgBatchDtoByObId: {name: "获取签发日期相关信息", code: "getOrgBatchDtoByObId"},
  editOrgBatchxx: {name: "编辑机构业务计划", code: "editOrgBatchxx"},

  getorgBatchsxx: {name: "查询认定机构业务计划", code: "getorgBatchsxx"},

  getConfirmWorkDataBasic: {name: "查询确认机构", code: "getConfirmWorkDataBasic"},

  getRegWebTransactFile: {name: "全程网办材料下载", code: "getRegWebTransactFile"},
// 国办
  abnormal: {name: "办件数据回传异常数据查询", code: "abnormal"},
  abnormales: {name: "办件数据回传异常数据查询", code: "abnormales"},
  gbTask: {name: "添加国办同步任务", code: "gbTask"},
  gbSyncInfoObt: {name: "查询网报时间段", code: "gbSyncInfoObt"},
  gbSyncInfo: {name: "获取需要推送国办的认定办结数据", code: "gbSyncInfo"},
  queryOrgId: {name: "根据token中的user_id查询org_id和org_type", code: "queryOrgId"},
  gbTaskAll: {name: "添加国办同步任务", code: "gbTaskAll"},
  gbStatistics: {name: "办理数据回传统计", code: "gbStatistics"},

  //注册批次设置
  viewCertApplyChange: {name: "证书申请变更详情", code: "viewCertApplyChange"},

  viewOrgAndProvinceBatch:{name:"认定机构计划(详情)",code:"viewOrgAndProvinceBatch"},
  delCertChangeAndDetail:{name:"撤销证书变更",code:"delCertChangeAndDetail"},


  enrollApprovelDownButton: {name: "下级机构注册审批按钮控制", code: "enrollApprovelDownButton"},
  enrollApprovelButton: {name: "本机构注册审批按钮控制", code: "enrollApprovelButton"},

  queryAllEnrollData: {name: "查询全国定期注册数据", code: "queryAllEnrollData"},
  approvalHistory: {name: "查询审批记录", code: "approvalHistory"},

  yesOrNoAddEnrollPlan: {name: "机构计划是否可以新增", code: "yesOrNoAddEnrollPlan"},
  provincePlannedBatch: {name: "省管理计划所属批次", code: "provincePlannedBatch"},
  myOrgIsExitsOrgBatchTimeAndLocalSet: {name: "本机构是否有网报时间段及确认点", code: "myOrgIsExitsOrgBatchTimeAndLocalSet"},

  approvalAfterCertList: {name: "审批后的证书列表", code: "approvalAfterCertList"},
  currentTimeBatchExists: {name: "查询当前时间是否有批次存在", code: "currentTimeBatchExists"},

  importScore:{name:"导入国考成绩",code:"importScore"},
  queryScoreImpfile:{name:"查看数据日志",code:"queryScoreImpfile"},

  importDeclarationNotAccepted: {name: "导入未受理", code: "importDeclarationNotAccepted"},
  importShouldRegNotRegInfoExcel: {name: "导入应注册未报名的信息", code: "importShouldRegNotRegInfoExcel"},
  importEnrollUnqualified: {name: "导入已报名却不符合注册条件信息", code: "importEnrollUnqualified"},
  exportApprovalEnrollData: {name: "导出注册数据", code: "exportApprovalEnrollData"},
  batchApprovalEnroll: {name: "批量审核", code: "batchApprovalEnroll"},

  detailCertChg: {name: "查询证书变更详情", code: "detailCertChg"},
  approvalCertList: {name: "证书审批列表", code: "approvalCertList"},
  beforeCertApprove: {name: "证书变更审批", code: "beforeCertApprove"},
  certificateChange: {name: "申请证书确认变更", code: "certificateChange"},
  applyCertChange: {name: "申请证书变更", code: "applyCertChange"},



  recoveryCert:{name:"证书恢复变更申请",code:"recoveryCert"},
  restoreCert: {name: "证书删除和恢复", code: "restoreCert"},
  deleteOrRestore: {name: "证书删除和恢复", code: "deleteOrRestore"},
  getDisplayOfApprovalTime: {name: "审批时间展示", code: "getDisplayOfApprovalTime"},
  cancelMessageRegistration: {name: "注册撤销留言", code: "cancelMessageRegistration"},
  resultAndInvokeChangeApproval: {name: "注册结论,撤销数据变更审批", code: "resultAndInvokeChangeApproval"},
  applicationRevokeData: {name: "申请撤销注册数据", code: "applicationRevokeData"},
  changeEnrollHistoryResult: {name: "申请变更注册结论", code: "changeEnrollHistoryResult"},
  endCertBatchEnroll: {name: "注册批次结束", code: "endCertBatchEnroll"},
  resultChangeApproveList: {name: "注册结论变更复核列表", code: "resultChangeApproveList"},
  resultChangeApproveDetail: {name: "查看注册结论变更,撤销数据变更", code: "resultChangeApproveDetail"},
  //  地方平台
  authTeachers: {name: "人工待审核数据列表", code: "authTeachers"},
  updateAuthById:{name:'实名核验',code:'updateAuthById'},
  exchangeMoesso:{name:'实名核验',code:'exchangeMoesso'},
  authTeacher:{name:'审核数据',code:"authTeacher"},
   ssoApp:{name:'照片token',code:"ssoApp"},
   stateRunabnormal:{name:'网办数据异常',code:"stateRunabnormal"},
   abnormalecho:{name:'重新上传',code:'abnormalecho'},
  /*applyForChangeCert:{name:"证书申请变更",code:"applyForChangeCert"},*/
  // updateFile:{name:'注册上传图片',code:"updateFile"},
  modifyLocalSetInfo: {name: "更换确认点", code: "modifyLocalSetInfo"},

  exportUniscOrg:{name:"导出机构统一信息",code:"exportUniscOrg"},
  registrationDataAcceptance: {name: "注册数据受理", code: "registrationDataAcceptance"},
  cancelMessagesRegAudEnroll: {name: "注册相关留言取消", code: "cancelMessagesRegAudEnroll"},

  importUniscOrg:{name:"信息代码证信息导入",code:"importUniscOrg"},
  getAllDownOrg:{name:"管理下级机构定期注册计划",code:"getAllDownOrg"},
  queryTreeDataBM: {name: "获取BaseMajor下拉treeData", code: "queryTreeDataBM"},
  queryTreeDataBTJ: {name: "获取BaseTechnical下拉treeData", code: "queryTreeDataBTJ"},


  editOrgBatchPlan:{name:"编辑机构计划",code:"editOrgBatchPlan"},
  lowerOrgbatchSuspensionOfReg: {name: "下级机构批量暂缓注册", code: "lowerOrgbatchSuspensionOfReg"},
  lowerOrgbatchQualified: {name: "下级机构批量合格", code: "lowerOrgbatchQualified"},
  lowerOrgbatchQualifiedByQuery: {name: "通过查询条件审批下级机构批量合格", code: "lowerOrgbatchQualifiedByQuery"},

  selfOrgbatchSuspensionRegistration: {name: "本机构批量展缓注册", code: "selfOrgbatchSuspensionRegistration"},
  queryEnrollHistoryData: {name: "注册历史数据管理", code: "queryEnrollHistoryData"},
  queryEnrollHistoryDataTemp: {name: "注册历史不通过数据管理", code: "queryEnrollHistoryDataTemp"},

  certEnrollRegistrationInfo: {name: "证书注册信息", code: "certEnrollRegistrationInfo"},

  certEnrollHistoryInfo: {name: "获取证书注册信息", code: "certEnrollHistoryInfo"},

  queryChangeBySource: {name: "查询信息变更项", code: "queryChangeBySource"},

  queryRegAudByRegId: {name: "通过认定编号查询认定审批信息", code: "queryRegAudByRegId"},
  registerPdfCredentials: {name: "认定受理凭证打印", code: "registerPdfCredentials"},

  deleteOrgBatchTime: {name: "删除网报时间段", code: "deleteOrgBatchTime"},
  editProvinceEnrollPlan: {name: "编辑省机构注册计划", code: "editProvinceEnrollPlan"},
  EnrollEditSiteOrg: {name: "编辑机构公示信息", code: "EnrollEditSiteOrg"},
  pdfCredentials: {name: "受理凭证打印", code: "pdfCredentials"},
  getUpOrgLevelOrg: {name: "上级机构注册计划", code: "getUpOrgLevelOrg"},
  queryCheckEnrollAud: {name: "查看核对留言信息", code: "queryCheckEnrollAud"},

  getMessagesRegAud: {name: "getMessagesRegAud", code: "getMessagesRegAud"},
  nowWorkInfoBaseDate: {name: "基础数据回显", code: "nowWorkInfoBaseDate"},
  getOrgAllInfo:{name:"机构信息",code:"getOrgAllInfo"},
  orgInfoQueryChange:{name:"机构信息变更记录",code:"orgInfoQueryChange"},
  orgChangeDetailInfo:{name:"机构信息变更详情",code:"orgChangeDetailInfo"},
  queryRessourceOtherCert:{name:"查询其他证书",code:"queryRessourceOtherCert"},

  viewOtherCert:{name:"查询其他证书详情",code:"viewOtherCert"},
  getLocalSetInfoDetail:{name:"查看计划确认点安排",code:"getLocalSetInfoDetail"},
  queryALLHistoryInfo:{name:"查询全国认定历史数据",code:"queryALLHistoryInfo"},
  historicalDataChangeDetails:{name:"历史数据变更详情",code:"historicalDataChangeDetails"},
  historyEnrollDataResultChangeLog:{name:"定期注册历史数据结论变更日志",code:"historyEnrollDataResultChangeLog"},
  getLocalSetDateByObtId: {name: "查看计划确认点列表", code: "getLocalSetDateByObtId"},
  addEnrollAud: {name: "给申请人留言", code: "addEnrollAud"},



  queryProvinceDownOrgName:{name:"查询该省下的机构名称",code:"queryProvinceDownOrgName"},
  queryCertChangedetail: {name: "证书变更记录详情列表", code: "queryCertChangedetail"},
  queryAllChangeDetailBYChgIdList: {name: "变更记录详情列表", code: "queryAllChangeDetailBYChgIdList"},

  applyOrgEnrollEndEdit: {name: "结束机构注册计划", code: "applyOrgEnrollEndEdit"},
  applyOrgEnrollFinshList: {name: "结束机构注册计划列表", code: "applyOrgEnrollFinshList"},

  applyEnrollFinshEdit: {name: "结束省厅注册计划", code: "applyEnrollFinshEdit"},
  applyEnrollFinshDetail: {name: "申请结束本省注册计划详情", code: "applyEnrollFinshDetail"},
  applyEnrollFinshList: {name: "申请结束本省注册计划", code: "applyEnrollFinshList"},

  applyEnrollFinshList1: {name: "申请结束本省注册计划", code: "applyEnrollFinshList1"},

  otherOrgEnrollDetail: {name: "其他机构注册数据详情", code: "otherOrgEnrollDetail"},
  otherOrgEnrollList: {name: "其他机构注册数据列表", code: "otherOrgEnrollList"},

  downOrgEnrollEdit: {name: "编辑下属机构注册数据", code: "downOrgEnrollEdit"},
  downOrgEnrollDelete: {name: "删除下属机构注册数据", code: "downOrgEnrollDelete"},

  downOrgEnrollDetail: {name: "查看下属机构注册数据详情", code: "downOrgEnrollDetail"},
  downOrgEnrollList: {name: "注册监控列表", code: "downOrgEnrollList"},

  EnrollMonitoringList: {name: "注册监控列表", code: "EnrollMonitoringList"},
  EnrollMonitoringView: {name: "注册监控详情", code: "EnrollMonitoringView"},


  editOrgBatchEnroll: {name: "编辑保存机构信息", code: "editOrgBatchEnroll"},

  queryCertChange: {name: "查询证书变更记录信息", code: "queryCertChange"},
  queryChange: {name: "查询变更记录信息", code: "queryChange"},

  addCertChange: {name: "新增证书变更", code: "addCertChange"},
  addLimitCert: {name: "新增限制库证书", code: "addLimitCert"},

  detailsOfApprovalAndRegistration: {name: "查看审批注册详情", code: "detailsOfApprovalAndRegistration"},


  queryAllEnrollFinshTheQuery: {name: "终审列表", code: "queryAllEnrollFinshTheQuery"},
  editAllEnrollCheckTheReg: {name: "复核确认", code: "editAllEnrollCheckTheReg"},
  queryAllEnrollCheckTheRegDetail: {name: "查看复核注册详情", code: "queryAllEnrollCheckTheRegDetail"},
  queryAllEnrollCheckTheQuery: {name: "查询复核信息列表", code: "queryAllEnrollCheckTheQuery"},

  queryAllEnrollHistoryCheckTheRegDetail: {name: "查看定期注册历史数据详情", code: "queryAllEnrollHistoryCheckTheRegDetail"},
  queryAllEnrollHistoryTempCheckTheRegDetail: {name: "查看定期注册历史不通过数据详情", code: "queryAllEnrollHistoryTempCheckTheRegDetail"},


  editEnrollmentFistAffirm: {name: "初审注册审批确认", code: "editEnrollmentFistAffirm"},
  queryEnrollFistCheckmentDetail: {name: "初审注册审批详情", code: "queryEnrollFistCheckmentDetail"},
  queryAllEnrollAudSubModel: {name: "注册审批初审信息列表", code: "queryAllEnrollAudSubModel"},
  editEnrollment: {name: "核对网络填报数据确认", code: "editEnrollment"},
  editAllEnrollFinshTheReg: {name: "终审审批确认", code: "editAllEnrollFinshTheReg"},

  queryAllEnrollLevelOrg: {name: "审批下级列表展示", code: "queryAllEnrollLevelOrg"},
  queryProvinceOrgEnrollPlan: {name: "查询省级机构注册计划", code: "queryProvinceOrgEnrollPlan"},
  editProvinceBatch: {name: "修改省级批次计划", code: "editProvinceBatch"},
  editPublicOrgSiteOrg: {name: "编辑机构公示信息", code: "editPublicOrgSiteOrg"},
  getAllDownOrgEnrollInfo: {name: "全部下级结构注册计划", code: "getAllDownOrgEnrollInfo"},
  addedConfirmationPointArrangement: {name: "新增确认点工作安排", code: "addedConfirmationPointArrangement"},
  editEnrollUser: {name: "修改确认点注册用户", code: "editEnrollUser"},
  delEnrollUser: {name: "删除确认点注册用户", code: "delEnrollUser"},
  addEnrollUser: {name: "添加确认点注册用户", code: "addEnrollUser"},
  queryOrgEnrollUser: {name: "查询认定用户", code: "queryOrgEnrollUser"},


  changeProvinceBatch: {name: "变更批次注册计划", code: "changeProvinceBatch"},
  querySetBatcherEnroll: {name: "查询注册批次", code: "querySetBatcherEnroll"},
  editSetBatcherEnroll: {name: "修改注册批次", code: "editSetBatcherEnroll"},
  endCertBatchxx: {name: "结束批次", code: "endCertBatchxx"},
  delSetBatcherEnroll: {name: "删除注册批次", code: "delSetBatcherEnroll"},
  addSetBatcherEnroll: {name: "新增注册批次", code: "addSetBatcherEnroll"},
  viewSetBatcherEnroll: {name: "查看注册批次详情", code: "viewSetBatcherEnroll"},

  querySelfProvince: {name: "查询注册批次", code: "querySelfProvince"},
  queryProvinceBatchSearch: {name: "搜索查询注册批次", code: "queryProvinceBatchSearch"},
  viewOneSelfProvince: {name: "查看注册详情", code: "viewOneSelfProvince"},
  delSetEnrollProvince: {name: "删除本省注册计划", code: "delSetEnrollProvince"},
  applyForAmendmentProvinceOrg: {name: "查看本省审批注册详情", code: "applyForAmendmentProvinceOrg"},
  queryProvinceBatchApprove: {name: "注册审批计划", code: "queryProvinceBatchApprove"},

  queryProvinceEnroll: {name: "查询省注册计划", code: "queryProvinceEnroll"},
  queryProvincePlan: {name: "查询注册计划", code: "queryProvincePlan"},
  queryProviceCertBatch: {name: "查询注册批次", code: "queryProviceCertBatch"},
  viewOrgBatchs: {name: "查询省级注册计划详情", code: "viewOrgBatchs"},
  viewOrgEnrollDetail: {name: "查看本机构业务计划详情", code: "viewOrgEnrollDetail"},


  querySelfOrg: {name: "本机构注册查询", code: "querySelfOrg"},
  getMyOrgEnroll: {name: "查询设置本机构注册网报计划", code: "getMyOrgEnroll"},
  getOrgLevelOrg: {name: "下级机构注册计划管理", code: "getOrgLevelOrg"},


  getMyOrgPlan: {name: "查看本机构注册计划", code: "getMyOrgPlan"},
  getMyOrgPlanDetail: {name: "查看本机构注册计划详情", code: "getMyOrgPlanDetail"},
  querySiteOrgCity: {name: "本机构查询机构信息", code: "querySiteOrgCity"},


  queryProvinceEnrollPlan: {name: "查询本省注册计划", code: "queryProvinceEnrollPlan"},
  getProvinceOrgPlan: {name: "查看下级注册管理", code: "getProvinceOrgPlan"},

  gwtConfirmWork: {name: "安排确认点工作", code: "gwtConfirmWork"},
  viewConfirmWork: {name: "安排确认点详情", code: "viewConfirmWork"},
  delConfirmWork: {name: "删除确认点安排", code: "delConfirmWork"},
  editConfirmWork: {name: "修改确认点安排", code: "editConfirmWork"},
  superiorProvinceRegistrationInformation: {name: "查询本机构上级省注册计划", code: "superiorProvinceRegistrationInformation"},
  provinceSelfApplyNewTime: {name: "查询本省最新注册网报时间", code: "provinceSelfApplyNewTime"},
  viewOrgEnrollDownlevelDetail: {name: "查看下级机构计划详情", code: "viewOrgEnrollDownlevelDetail"},


  netAtTime: {name: "网报时间段", code: "netAtTime"},
  addProvinceBatch: {name: "新增省注册计划", code: "addProvinceBatch"},

  addBaseOrgEnrollBasic: {name: "确认点添加", code: "addBaseOrgEnrollBasic"},

  getLocaleManageData: {name: "查询确认点安排", code: "getLocaleManageData"},
  viewLocaleSetDetail: {name: "查看确认点安排详情", code: "viewLocaleSetDetail"},
  deleteLocaleSet: {name: "删除确认点安排", code: "deleteLocaleSet"},
  editManagerLocaleSet: {name: "编辑确认点安排", code: "editManagerLocaleSet"},
  addManagerLocaleSet: {name: "新增确认点安排", code: "addManagerLocaleSet"},
  provincialPlanEnquiry: {name: "本机构查询省级计划", code: "provincialPlanEnquiry"},

  queryOrgInfo: {name: "查询机构", code: "queryOrgInfo"},
  editSiteOrg: {name: "更新机构信息", code: "editSiteOrg"},

  getConfirmPointData: {name: "确认工作安排确认机构", code: "getConfirmPointData"},
  /*getConfirmPointDataBasic:{name:"确认工作安排确认机构",code:"getConfirmPointDataBasic"},*/

  getCurrentOrgBatchEnrollTimes: {name: "获取本机构注册网报时间计划", code: "getCurrentOrgBatchEnrollTimes"},
  queryBaseOrgEnrollBasic: {name: "查询机构", code: "queryBaseOrgEnrollBasic"},

  addOrgEnroll: {name: "新增本机构注册计划", code: "addOrgEnroll"},
  getProvinceAndParentOrgTime: {name: "查询本机构所属省的网报开始结束,上级机构复核", code: "getProvinceAndParentOrgTime"},
  //初审注册审批
  queryEnrollment: {name: "核对网络填报数据", code: "queryEnrollment"},
  queryEnrollAud: {name: "用户初审注册审批", code: "queryEnrollAud"},
  queryEnrollmentDetail: {name: "查看核对网络填报数据详情", code: "queryEnrollmentDetail"},

  addBaseOrg2: {name: "新增确认点安排", code: "addBaseOrg2"},

  //认定新增
  editBaseOrgBatchAssignSetDefault: {name: '修改机构签发日期默认选择', code: 'editBaseOrgBatchAssignSetDefault'},
  editBaseOrgBatchAssignCheckOpen: {name: '设置机构签发日期是否弹出', code: 'editBaseOrgBatchAssignCheckOpen'},

  getBaseOrgBatchAssignOpenSet: {name: '机构签发日期不弹出返回签发日期', code: 'getBaseOrgBatchAssignOpenSet'},
  editBaseOrgBatchAssignCheckClose: {name: '机构签发日期弹出关闭', code: 'editBaseOrgBatchAssignCheckClose'},

  cancelMessagesRegAud: {name: '取消留言信息', code: 'cancelMessagesRegAud'},

  zzStatus: {name: '准入查询数据状态', code: 'zzStatus'},
  zzData: {name: '准入查询有问题数据', code: 'zzData'},
  fuyiData: {name: '准入查询复议', code: 'fuyiData'},
  sendData: {name: '手工申请准入查询', code: 'sendData'},
  queryOrgInfoxx: {name: "查询公示机构信息", code: "queryOrgInfoxx"},
  queryOrgInfoCertxx: {name: "查询机构信息显示", code: "queryOrgInfoCertxx"},
  netAtTimexx: {name: "网报时间段", code: "netAtTimexx"},
  addProvinceBatchPostponexx: {name: "添加省级批次计划调整", code: "addProvinceBatchPostponexx"},
  queryOrgInfoCertificatexx: {name: "查询机构信息显示", code: "queryOrgInfoCertificatexx"},
  viewRegistrationxx: {name: "查询用户申请报名信息", code: "viewRegistrationxx"},

  viewRegistrationxxx: {name: "证书相关信息", code: "viewRegistrationxxx"},

  getTeacherScores: {name: "查询申请人考试和免试证书信息", code: "getTeacherScores"},


  getCurrentYearProvinceBatchxx: {name: "获取本省当年批次", code: "getCurrentYearProvinceBatchxx"},
  queryOrgNamesByOrgIdsxx: {name: "根据id获取机构名", code: "queryOrgNamesByOrgIdsxx"},
  queryCertificateUser: {name: "查询认定用户", code: "queryCertificateUser"},
  getAdminDtoById: {name: "根据用户id查询用户", code: "getAdminDtoById"},
  updateConfirmBaseOrgBasic: {name: "修改确认机构", code: "updateConfirmBaseOrgBasic"},
  delCertificateUser: {name: "删除认定用户", code: "delCertificateUser"},
  editCertificateUser: {name: "修改认定用户", code: "editCertificateUser"},
  exportLocaleSetUser: {name: "导出确认点用户", code: "exportLocaleSetUser"},
  importLocaleSetUser: {name: "导入确认点用户", code: "importLocaleSetUser"},
  queryOrgBatchTimexx: {name: "获取机构的网报计划", code: "queryOrgBatchTimexx"},
  getCurrentOrgBatchTimesxx: {name: "获取本机构当前的网报计划", code: "getCurrentOrgBatchTimesxx"},
  addCertificateUser: {name: "添加认定用户", code: "addCertificateUser"},
  queryResume: {name: "查询申请用户简历", code: "queryResume"},
  exportRmsAdminBase: {name: "导出exportRmsAdminBase", code: "exportRmsAdminBase"},
  addRegAud: {name: "新增用户确认申请报名表", code: "addRegAud"},
  batchResetPassword: {name: "批量修改认定用户密码", code: "batchResetPassword"},
  singleResetPassword: {name: "单个修改认定用户密码", code: "singleResetPassword"},
  auditProvinceBatchxx: {name: "审批省级批次计划", code: "auditProvinceBatchxx"},
  batchAddLocaleSetxx: {name: "批量新增确认点安排", code: "batchAddLocaleSetxx"},
  confirmRegistrationxx: {name: "核对网络填报数据确认", code: "confirmRegistrationxx"},
  batchMsgxx: {name: "核对网络填报数据确认新的", code: "batchMsgxx"},
  affirmRegistrationxx: {name: "核对网络填报数据认定", code: "affirmRegistrationxx"},
  queryMyOrgBatchToEndxx: {name: "查询申请结束本机构认定批次", code: "queryMyOrgBatchToEndxx"},
  queryOrgPublicInfoxx: {name: "查询机构公示信息详情", code: "queryOrgPublicInfoxx"},
  queryCurrentOrgBatchxx: {name: "查询最新本机构计划", code: "queryCurrentOrgBatchxx"},
  updateSiteOrgxx: {name: "提交机构公示信息", code: "updateSiteOrgxx"},
  querySiteOrgInfo: {name: "查询公示机构信息显示", code: "querySiteOrgInfo"},
  viewCollegeCertxx: {name: "查询学历证书详情", code: "viewCollegeCertxx"},
  viewDegreeCertxx: {name: "查询学位证书详情", code: "viewDegreeCertxx"},
  viewPthCertxx: {name: "查询普通话证书详情", code: "viewPthCertxx"},
  viewStudentCertxx: {name: "查询学籍详情", code: "viewStudentCertxx"},
  batchAudxx: {name: "批量审核用户报名信息", code: "batchAudxx"},
  getRegImagexx: {name: "查询申请人图片", code: "getRegImagexx"},
  getUuidxx: {name: "获取uuid", code: "getUuidxx"},

  getCertRegImage: {name: "查询申请人图片", code: "getCertRegImage"},
  getCertUuidxx: {name: "获取uuid", code: "getCertUuidxx"},

  addCertAssign: {name: "新增证书签收信息", code: "addCertAssign"},
  queryCertAssign: {name: "查询证书签收信息", code: "queryCertAssign"},
  delCertAssign: {name: "删除证书签收信息", code: "delCertAssign"},
  viewCertAssign: {name: "获取证书签收信息", code: "viewCertAssign"},
  editCertAssign: {name: "修改证书签收信息", code: "editCertAssign"},
  addCertApply: {name: "新增证书申领信息", code: "addCertApply"},
  queryCertApply: {name: "查询证书申领信息", code: "queryCertApply"},
  delCertApply: {name: "删除证书申领信息", code: "delCertApply"},
  viewCertApply: {name: "获取证书申领信息", code: "viewCertApply"},
  editCertApply: {name: "修改证书申领信息", code: "editCertApply"},
  addCertAddition: {name: "新增证书补发换发信息", code: "addCertAddition"},
  queryCertAddition: {name: "查询证书补发换发信息", code: "queryCertAddition"},
  delCertAddition: {name: "删除证书补发换发信息", code: "delCertAddition"},
  viewCertAddition: {name: "获取证书补发换发信息", code: "viewCertAddition"},
  editCertAddition: {name: "修改证书补发换发信息", code: "editCertAddition"},
  addCert: {name: "新增教师资格证书信息", code: "addCert"},
  queryCert: {name: "查询教师资格证书信息", code: "queryCert"},
  querySsoUserAllCerts: {name: "查询申请人所有证书信息", code: "querySsoUserAllCerts"},
  removeCertCache: {name: "删除教师资格证书缓存信息", code: "removeCertCache"},
  viewCert: {name: "获取教师资格证书信息", code: "viewCert"},
  editCert: {name: "修改教师资格证书信息", code: "editCert"},
//申请人信息
  querySsouserCollegeCert: {name: "查询学历证书信息", code: "querySsouserCollegeCert"},
  removeSsouserCollegeCert: {name: "删除申请人学历信息的缓存信息", code: "removeSsouserCollegeCert"},
  editSsouser:{name: "修改申请人信息", code: "editSsouser"},
  // delSsouserCollegeCert:{name: "删除学历证书信息", code: "delSsouserCollegeCert" },
  viewSsouserCollegeCert: {name: "获取学历证书信息", code: "viewSsouserCollegeCert"},
  querySsouserPthCert: {name: "查询普通话证书信息", code: "querySsouserPthCert"},
  // delSsouserPthCert:{name: "删除普通话证书信息", code: "delSsouserPthCert" },
  removeSsouserPthCertCache: {name: "删除申请人普通话信息的缓存信息", code: "removeSsouserPthCertCache"},
  viewSsouserPthCert: {name: "获取普通话证书信息", code: "viewSsouserPthCert"},
  querySsouserStudent: {name: "查询学籍信息", code: "querySsouserStudent"},
  removeSsouserStudentCache: {name: "删除申请人普通话信息的缓存信息", code: "removeSsouserStudentCache"},
  viewSsouserStudent: {name: "获取学籍信息", code: "viewSsouserStudent"},
  queryNormalPreServiceTeacher: {name: "查询免试师范生信息", code: "queryNormalPreServiceTeacher"},
  removeNormalPreServiceTeacherCache: {name: "删除免试师范生信息", code: "removeNormalPreServiceTeacherCache"},
  viewNormalPreServiceTeacher: {name: "获取免试师范生信息", code: "viewNormalPreServiceTeacher"},
  querySsouser: {name: "查询申请人信息", code: "querySsouser"},
  // delSsouser:{name: "删除申请人信息", code: "delSsouser" },
  removeSsouserCache: {name: "删除申请人缓存信息", code: "removeSsouserCache"},
  removeSsouserBatchCache: {name: "删除申请人登录错误次数的缓存信息", code: "removeSsouserBatchCache"},
  removeSsouserAuthErrorCountCache: {name: "删除申请人登录错误次数的缓存信息", code: "removeSsouserAuthErrorCountCache"},
  viewSsouser: {name: "获取申请人信息", code: "viewSsouser"},
  queryScore: {name: "查询国考信息", code: "queryScore"},
  queryNormalPreServiceTeacherByApplyer: {name: "根据个人编号查询免试信息", code: "queryNormalPreServiceTeacherByApplyer"},
  queryScoreByApplyer: {name: "根据个人编号查询学籍信息", code: "queryScoreByApplyer"},
  removeScoreCache: {name: "删除申请人国考信息的缓存信息", code: "removeScoreCache"},
  viewScore: {name: "获取国考信息", code: "viewScore"},

  addSsouserDegreeCert: {name: "新增学位信息", code: "addSsouserDegreeCert"},
  querySsouserDegreeCert: {name: "查询学位信息", code: "querySsouserDegreeCert"},
  removeSsouserDegreeCertCache: {name: "删除申请人学位信息的缓存信息", code: "removeSsouserDegreeCertCache"},
  viewSsouserDegreeCert: {name: "获取学位信息", code: "viewSsouserDegreeCert"},
  editSsouserDegreeCert: {name: "修改学位信息", code: "editSsouserDegreeCert"},

  editSsouserCollegeCert: {name: "修改学历核验状态", code: "editSsouserCollegeCert"},

  editSsouserStudent: {name: "修改学籍核验状态", code: "editSsouserStudent"},

  editSsouserPthCert: {name: "修改学籍核验状态", code: "editSsouserPthCert"},

  getRmsSSO: {name: "单点登录", code: "getRmsSSO"},
  getRmsUserUsbKeyDataBasic: {name: "获取用户usekey", code: "getRmsUserUsbKeyDataBasic"},
  getRmsUserUsbKey: {name: "获取用户usekey详情", code: "getRmsUserUsbKey"},
  getUnUsbKeyOfProvince: {name: "根据用户id获取未分配的usbKey", code: "getUnUsbKeyOfProvince"},
  setUserUsbKey: {name: "设置用户usbkey", code: "setUserUsbKey"},
  addUsbKeys: {name: "添加usbkeys", code: "addUsbKeys"},

  batchALLAllowQuery: {name: "(取消)本机构下所有申请提供证书验证", code: "batchALLAllowQuery"},
  batchAllowQuery: {name: "(取消)申请提供证书验证", code: "batchAllowQuery"},
  handleCancelQuery: {name: "取消提供证书验证", code: "handleCancelQuery"},

  exportUsbKey: {name: "导出USBKEY", code: "exportUsbKey"},
  regReport: {name: "打印申请表", code: "regReport"},
  regOverInfoReport: {name: "打印总览信息表", code: "regOverInfoReport"},
  enrollReport:{name:"打印申请表",code:"enrollReport"},

  changeRequestInfo:{name:"变更申请信息",code:"changeRequestInfo"},
  resultApproveDetail:{name:"注册结论审批详情",code:"resultApproveDetail"},
  querySupplementCert:{name:"查询补添证书信息",code:"querySupplementCert"},
  getImage: {name: "获取照片", code: "getImage"},
  querySubjectBasic: {name: "获取subject下拉treeData", code: "querySubjectBasic"},
  regDataChange: {name: "认定历史数据变更", code: "regDataChange"},
  queryRegChgDos: {name: "查询认定变更数据", code: "queryRegChgDos"},
  viewRegChg: {name: "查询认定变更详情", code: "viewRegChg"},
  regChgAudit: {name: "审批认定变更", code: "regChgAudit"},
  queryMsgemail: {name: "查询邮件信息", code: "queryMsgemail"},
  viewMsgemail: {name: "获取邮件信息", code: "viewMsgemail"},
  editMsgemail: {name: "修改邮件信息", code: "editMsgemail"},
  queryMonalert: {name: "查询告警信息", code: "queryMonalert"},
  viewMonalert: {name: "获取告警信息", code: "viewMonalert"},
  editMonalert: {name: "修改告警信息", code: "editMonalert"},
  addMonAlertInform: {name: "新增告警通知信息", code: "addMonAlertInform"},
  queryMonAlertInform: {name: "查询告警通知信息", code: "queryMonAlertInform"},
  viewMonAlertInform: {name: "获取告警通知信息", code: "viewMonAlertInform"},
  editMonAlertInform: {name: "修改告警通知信息", code: "editMonAlertInform"},
  getInfos: {name: "查询信息", code: "getInfos"},
  getqueryInfos: {name: "查询信息列表", code: "getqueryInfos"},
  getReportDataPreview: {name: "根据ID获取统计分析信息（预览）", code: "getReportDataPreview"},
  getReportDataPreviewTask: {name: "根据ID获取统计分析信息结果任务记录", code: "getReportDataPreviewTask"},
  queryReportFileTask: {name: "查询统计报表生成文件", code: "queryReportFileTask"},
  viewReportFileTask: {name: "查询统计报表生成文件详情", code: "viewReportFileTask"},
  downReportFileTask: {name: "查询统计报表生成文件", code: "downReportFileTask"},

  Delreports: {name: "删除信息列表", code: "Delreports"},

  getReportHead: {name: "获取报表信息头", code: "getReportHead"},
  delReportInfo: {name: "删除报表信息头", code: "delReportInfo"},
  getReportInfos: {name: "获取报表信息", code: "getReportInfos"},


  addReportInfos: {name: "新增查询报表", code: "addReportInfos"},


  getReportQuery: {name: "获取报表信息条件", code: "getReportQuery"},

  queryLimitationByStatus: {name: "根据审批状态或发布状态查询本机构限制库", code: "queryLimitationByStatus"},
  queryNationLimitation: {name: "查询全国机构限制库", code: "queryNationLimitation"},
  addRestrictionLibrary: {name: "新增限制库数据", code: "addRestrictionLibrary"},
  queryLimitationOther: {name: "查询其他机构限制库数据", code: "queryLimitationOther"},
  queryLimitationPush: {name: "限制库推送记录查询", code: "queryLimitationPush"},
  downloadDecisionFile: {name: '下载文件', code: 'downloadDecisionFile'},
  uploadDecisionFile: {name: '上传', code: 'uploadDecisionFile'},
  viewLegalTerms: {name: "查询法律条款", code: "viewLegalTerms"},

  exportBaseOrgSchool: {name: "导出中小学信息", code: "exportBaseOrgSchool"},
  importBaseOrgSchool: {name: "导入中小学信息", code: "importBaseOrgSchool"},
  getImportBaseOrgSchool: {name: "查询导入中小学信息导入情况", code: "getImportBaseOrgSchool"},
  addBaseOrgSchool: {name: "新增中小学信息", code: "addBaseOrgSchool"},
  queryBaseOrgSchool: {name: "查询中小学信息", code: "queryBaseOrgSchool"},
  delBaseOrgSchool: {name: "删除中小学信息", code: "delBaseOrgSchool"},
  viewBaseOrgSchool: {name: "获取中小学信息", code: "viewBaseOrgSchool"},
  editBaseOrgSchool: {name: "修改中小学信息", code: "editBaseOrgSchool"},

  delRegistrationxx: {name: "删除认定数据", code: "delRegistrationxx"},
  queryHistoryValid: {name: "查询认定历史数据", code: "queryHistoryValid"},

  queryHistoryTemp: {name: "查看认定历史未通过数据", code: "queryHistoryTemp"},
  queryHistoryValidTemp: {name: "查看广西2012年前认定历史数据", code: "queryHistoryValidTemp"},

  queryALLHistoryValid: {name: "查询全国认定历史数据", code: "queryALLHistoryValid"},
  viewHistoryValid: {name: "查看全国认定历史数据", code: "viewHistoryValid"},

  viewHistoryTemp: {name: "查看认定历史临时数据", code: "viewHistoryTemp"},

  removeSsouserAuthCache: {name: "清除实名核验信息", code: "removeSsouserAuthCache"},
  removeSsouserRegCache: {name: "删除申请人认定报名缓存信息", code: "removeSsouserRegCache"},
  removeSsouserEnrollCache: {name: "删除申请人定期注册报名缓存信息", code: "removeSsouserEnrollCache"},


  queryBaseOrgBatchAssign: {name: "查询机构签发日期表", code: "queryBaseOrgBatchAssign"},
  addBaseOrgBatchAssign: {name: "新增机构签发日期表", code: "addBaseOrgBatchAssign"},
  updateBaseOrgBatchAssign: {name: "查询机构签发日期表", code: "updateBaseOrgBatchAssign"},

  queryRegSiteOrgDoList: {name: "查询认定机构公示信息", code: "queryRegSiteOrgDoList"},
  queryEnrollSiteOrgDoList: {name: "查询定期注册机构公示信息", code: "queryEnrollSiteOrgDoList"},

  viewSiteOrgDo: {name: "查看机构公示详情", code: "viewSiteOrgDo"},
  editBaseSiteOrg: {name: "编辑机构公示信息", code: "editBaseSiteOrg"},
  siteOrgReleaseApply: {name: "机构信息公示发布申请", code: "siteOrgReleaseApply"},
  siteOrgEnrollReleaseApply: {name: "机构信息公示发布申请", code: "siteOrgEnrollReleaseApply"},

  reviewRegSiteOrgDoList: {name: "预览机构公示发布信息", code: "reviewRegSiteOrgDoList"},

  querySsouserAccessquery: {name: "查询性侵准入查询信息", code: "querySsouserAccessquery"},
  viewSsouserAccessquery: {name: "获取性侵准入查询信息", code: "viewSsouserAccessquery"},
  getAccessQueryStatus: {name: "获取准入查询状态数量", code: "getAccessQueryStatus"},

  addEduDoc: {name: "新增资料下载", code: "addEduDoc"},
  queryEduDoc: {name: "查询资料下载", code: "queryEduDoc"},
  delEduDoc: {name: "删除资料下载", code: "delEduDoc"},
  viewEduDoc: {name: "获取资料下载", code: "viewEduDoc"},
  editEduDoc: {name: "修改资料下载", code: "editEduDoc"},

  audit: {name: "获取历史记录", code: "audit"},
  gbsso: {name: "统一身份认证对接开关", code: "gbsso"},
  authentication: {name: "实名核验开关", code: "authentication"},
  suspend: {name: "实名核验临时维护开关", code: "suspend"},

  gbssoPost: {name: "设置统一身份认证对接开关", code: "gbssoPost"},
  authenticationPost: {name: "设置实名核验开关", code: "authenticationPost"},
  suspendPost: {name: "设置实名核验临时维护开关", code: "suspendPost"},

  getBaseOrgInfo:{name:"机构相关信息",code:"getBaseOrgInfo"},
  exporRegExcelData: {name: "获取认定excel导出文件任务", code: "exporRegExcelData"},
  downRegExcelFile: {name: "下载认定excel文件", code: "downRegExcelFile"},
  exporRegExcelTask: {name: "导出机构认定数据任务列表", code: "exporRegExcelTask"},
  approvalEnrollHistory:{name:"approvalEnrollHistory",code:"approvalEnrollHistory"},
  downEnrollExcelFile:{name:"下载注册excel文件",code:"downEnrollExcelFile"},

  autoAudEnrollExcelData: {name: "机构批量审批注册数据", code: "autoAudEnrollExcelData"},
  autoAudEnrollTask: {name: "导出机构注册数据任务列表", code: "autoAudEnrollTask"},
  downAutoAudEnrollExcelFile:{name:"下载机构批量审批注册失败数据文件",code:"downAutoAudEnrollExcelFile"},



  exporEnrollExcelData: {name: "获取注册excel导出文件任务", code: "exporEnrollExcelData"},
  exporEnrollExcelTask: {name: "导出机构注册数据任务列表", code: "exporEnrollExcelTask"},


  changeKeepOnRecordPdf:{name:"证书变更备案PDF",code:"changeKeepOnRecordPdf"},
  addBaseOrgDoc:{name: "新增机构备案申请管理", code: "addBaseOrgDoc" },
  queryBaseOrgDoc:{name: "查询机构备案申请管理", code: "queryBaseOrgDoc" },
  delBaseOrgDoc:{name: "删除机构备案申请管理", code: "delBaseOrgDoc" },
  viewBaseOrgDoc:{name: "获取机构备案申请管理", code: "viewBaseOrgDoc" },
  editBaseOrgDoc:{name: "修改机构备案申请管理", code: "editBaseOrgDoc" },

  viewBaseOrgDocExcelHeader:{name: "获取机构备案申请管理授权字段", code: "viewBaseOrgDocExcelHeader" },

  editBatchBaseOrgDoc:{name: "批量修改机构备案申请管理", code: "editBatchBaseOrgDoc" },


  addEcertChange:{name: "新增电子证书变更", code: "addEcertChange" },
  queryEcertChange:{name: "查询电子证书变更", code: "queryEcertChange" },
  viewEcertChange:{name: "获取电子证书变更", code: "viewEcertChange" },
  editEcertChange:{name: "修改电子证书变更", code: "editEcertChange" },
  addEcertCert:{name: "新增电子证书", code: "addEcertCert" },
  queryEcertCert:{name: "查询电子证书", code: "queryEcertCert" },
  viewEcertCert:{name: "获取电子证书", code: "viewEcertCert" },
  editEcertCert:{name: "修改电子证书", code: "editEcertCert" },
  addEcertOrgStamp:{name: "新增机构电子证照信息", code: "addEcertOrgStamp" },
  queryEcertOrgStamp:{name: "查询机构电子证照信息", code: "queryEcertOrgStamp" },
  viewEcertOrgStamp:{name: "获取机构电子证照信息", code: "viewEcertOrgStamp" },
  editEcertOrgStamp:{name: "修改机构电子证照信息", code: "editEcertOrgStamp" },

  auditEcertOrgStamp:{name: "修改机构电子证照信息", code: "editEcertOrgStamp" },

  getOrgEcertRange:{name: "获取机构电子证照批次生成状态", code: "getOrgEcertRange" },

  addEcertOrgStampTask:{name: "新增电子证照任务", code: "addEcertOrgStampTask" },
  queryEcertTask:{name: "查询电子证照任务情况", code: "queryEcertTask" },
  viewEcertTask:{name: "获取电子证照任务情况", code: "viewEcertTask" },
  editEcertTask:{name: "修改电子证照任务情况", code: "editEcertTask" },

  queryUserByMessage:{name: "查询发送用户", code: "queryUserByMessage" },

  addMsgSysmsg:{name:"发送系统消息",code:"addMsgSysmsg"}

};
export default {
  permissions,
};



// WEBPACK FOOTER //
// ./src/http/permission.js